import React from "react"

import styles from "./UINotificationBadge.module.scss"

export const UINotificationBadge = (props: {count: number | string, style?: React.CSSProperties}) => {
    return  <span className={styles.badge} style={props.style}>
                {props.count}
            </span>
}